(function () {
  function used(config, items, id) {
    return items.reduce((total, item) => total + (String(item.product_id) === String(id) ? Number(item.quantity) : 0) + Number(config.components?.[String(item.product_id)]?.[String(id)] || 0) * Number(item.quantity), 0);
  }
  function remaining(config, items, id) {
    let room = config.limits?.[String(id)] == null ? 99 : Number(config.limits[String(id)]) - used(config, items, id);
    Object.entries(config.components?.[String(id)] || {}).forEach(([component, count]) => {
      if (config.limits?.[component] != null && count > 0) room = Math.min(room, Math.floor((Number(config.limits[component]) - used(config, items, component)) / count));
    });
    return Math.max(0, room);
  }
  function suggest(config, items, products) {
    if (!items.length) return [];
    const cartIds = new Set(items.map(item => String(item.product_id)));
    const valid = products.filter(product => product.available && !cartIds.has(String(product.id)) && remaining(config, items, product.id) > 0);
    const chosen = [];
    const pick = (handle, reason) => { const product = valid.find(product => product.handle === handle); if (product && !chosen.includes(product)) { chosen.push(product); product.reason = reason; } };
    if (items.some(item => item.handle === 'projeto-21-dias')) pick('projeto-42-dias', 'Mais jantares para sua rotina: conheça o Projeto 42 Dias.');
    if (items.some(item => /aveia/.test(item.handle || ''))) pick('mel-holy-330g', 'Combina com sua aveia: um toque de mel no café da manhã.');
    if (items.some(item => item.handle === 'mel-holy-330g')) {
      const oatmeal = valid.find(product => /aveia/.test(product.handle || ''));
      if (oatmeal) pick(oatmeal.handle, 'Combina com seu mel: uma aveia para o café da manhã.');
    }
    if (items.reduce((sum, item) => sum + Number(item.quantity), 0) <= 5 && chosen.length < 2) {
      const flavor = valid.find(product => product.promo);
      if (flavor) pick(flavor.handle, 'Que tal variar com mais um sabor do 10.10?');
    }
    return chosen.slice(0, 2);
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { remaining, suggest }; return; }
  const config = window.HS_CART_QTY_LIMITS;
  if (!config?.enabled) return;
  let cart = null, revision = 0, scheduled;
  const root = window.Shopify?.routes?.root || '/';
  const money = value => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100);
  function renderLimits() {
    if (!cart) return;
    document.querySelectorAll('[data-hc-product-id]').forEach(card => {
      const id = card.dataset.hcProductId;
      if (config.limits?.[id] == null && !config.components?.[id]) return;
      const room = remaining(config, cart.items, id);
      const isCart = card.classList.contains('side-cart-item-product');
      card.dataset.holyRemaining = String(room);
      let message = card.querySelector('[data-holy-limit-status]');
      if (!isCart) {
        message?.remove();
      } else {
        if (!message) {
          message = document.createElement('p'); message.className = 'holy-1010-limit-status'; message.dataset.holyLimitStatus = '';
          message.setAttribute('role', 'status');
          const target = card.querySelector('.item-product-title');
          (target || card).appendChild(message);
        }
        message.textContent = room === 0 ? 'Limite atingido' : `Pode adicionar mais ${room}`;
      }
      const input = card.querySelector('input[name="quantity"],select[name="quantity"]');
      if (input && !isCart) {
        input.max = String(Math.max(1, room));
        if (input.tagName === 'SELECT') [...input.options].forEach(option => { option.disabled = Number(option.value) > room; });
        if (room > 0 && Number(input.value) > room) { input.value = room; input.dispatchEvent(new Event('input', { bubbles: true })); input.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      const plus = card.querySelector('[data-hc-step="1"],button[aria-label^="Aumentar quantidade"]');
      if (plus) plus.disabled = room === 0 || (!isCart && Number(input?.value || 1) >= room);
      if (!isCart) {
        const add = card.querySelector('button[type="submit"],.hs-card-add-button');
        if (add) {
          if (room === 0 && !add.dataset.holyLimited && !add.disabled) { add.dataset.holyLimited = 'true'; add._holyOriginalLabel = add.innerHTML; add.disabled = true; add.textContent = 'Limite atingido'; }
          else if (room > 0 && add.dataset.holyLimited) { add.disabled = false; add.innerHTML = add._holyOriginalLabel; delete add.dataset.holyLimited; }
        }
      } else if (input) input.max = String(Number(input.value) + room);
    });
  }
  function renderSuggestions() {
    const host = document.querySelector('[data-holy-cart-recommendations]');
    if (!host || !cart) return;
    const data = host.querySelector('script[data-holy-recommendation-products]');
    const list = host.querySelector('[data-holy-recommendation-list]');
    if (!data || !list) return;
    const products = JSON.parse(data.textContent);
    const choices = suggest(config, cart.items, products);
    host.hidden = !choices.length;
    list.replaceChildren();
    choices.forEach(product => {
      const row = document.createElement('article'); row.className = 'holy-1010-cart-suggestion';
      const image = document.createElement('img'); image.src = product.image; image.alt = product.title; image.loading = 'lazy'; image.width = 64; image.height = 72;
      const content = document.createElement('div');
      const reason = document.createElement('p'); reason.textContent = product.reason;
      const title = document.createElement('a'); title.href = product.url; title.textContent = product.title;
      const price = document.createElement('strong'); price.textContent = money(product.price);
      const add = document.createElement('button'); add.type = 'button'; add.textContent = '+ ADICIONAR'; add.setAttribute('aria-label', 'Adicionar ' + product.title + ' ao carrinho');
      add.addEventListener('click', async () => {
        add.disabled = true; add.textContent = 'Adicionando…';
        try {
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: {'Content-Type':'application/json',Accept:'application/json'}, body: JSON.stringify({items:[{id:product.variant,quantity:1}]}) });
          const result = await response.json();
          if (!response.ok) throw Error(result.description || 'Não foi possível adicionar.');
          window.dispatchEvent(new CustomEvent('cart-change')); window.Alpine?.store('cart')?.fetchItems?.();
          refresh();
        } catch (error) { reason.textContent = error.message; add.disabled = false; add.textContent = '+ ADICIONAR'; }
      });
      content.append(reason, title, price); row.append(image, content, add); list.appendChild(row);
    });
  }
  function render() { renderLimits(); renderSuggestions(); }
  async function refresh() {
    const current = ++revision;
    try {
      const response = await fetch(root + 'cart.js', { cache: 'no-store', headers: {Accept:'application/json'} });
      if (!response.ok) return;
      const next = await response.json(); if (current !== revision) return;
      cart = next; render();
    } catch { /* The existing server-backed cart guard remains active if this display cannot refresh. */ }
  }
  window.addEventListener('cart-change', () => { clearTimeout(scheduled); scheduled = setTimeout(refresh, 200); });
  window.addEventListener('hs:cart-rendered', () => { render(); refresh(); });
  window.addEventListener('show-cart', refresh);
  document.addEventListener('shopify:section:load', render);
  document.addEventListener('click', event => {
    const plus = event.target.closest('[data-hc-step="1"],button[aria-label^="Aumentar quantidade"]');
    const card = plus?.closest('[data-hc-product-id]');
    if (!card || card.dataset.holyRemaining === undefined) return;
    const quantity = Number(card.querySelector('[name="quantity"]')?.value || 1);
    if (Number(card.dataset.holyRemaining) === 0 || (!card.classList.contains('side-cart-item-product') && quantity >= Number(card.dataset.holyRemaining))) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('change', event => { if (event.target.matches('[name="quantity"]')) renderLimits(); });
  refresh();
})();
